export const VIDEO_TAG_NAME = 'VIDEO';

export const EVENT_CATEGORY_CONTENT = 'Контент';

export const AD_EVENT = 'adEvent';

export const MAIN_EVENT = 'mainEvent';
